import React, { useState } from "react";
import "./Navbar.css";
import logo from "../Assets/logo1.png";
import { FaSearch, FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [activeCollection, setActiveCollection] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
        setActiveCollection(null);
    };

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    const handleCollectionClick = (collection) => {
        setActiveCollection((prev) => (prev === collection ? null : collection));
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <nav className="navbar">
            <div className="nav-logo">
                <img src={logo} alt="Dewalegama Jewellers Logo" />
                <h2>Dewalegama Jewellers</h2>
            </div>

            <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
                <li><a href="/" onClick={closeMenu}>Home</a></li>
                <li><a href="/category" onClick={closeMenu}>Our Collections</a></li>
                <li><a href="/about" onClick={closeMenu}>About Us</a></li>
                <li><a href="/contact" onClick={closeMenu}>Contact Us</a></li>
            </ul>

            <div className="nav-icons">
                {/* Hamburger Icon - Shows on mobile */}
                <div className="hamburger" onClick={toggleMenu}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </div>

                <FaSearch className="icon" onClick={toggleDropdown} />

                {/* ✅ ADMIN ICON NOW LINKS TO /admin */}
                
            </div>

            {/* Dropdown Menu */}
            {showDropdown && (
                <div className="dropdown-panel">

                    {/* MAIN COLLECTIONS */}
                    <div
                        className="dropdown-item"
                        onClick={() => handleCollectionClick("gold")}
                    >
                        Gold Collection
                    </div>

                    <div
                        className="dropdown-item"
                        onClick={() => handleCollectionClick("silver")}
                    >
                        Silver Collection
                    </div>

                    <div
                        className="dropdown-item"
                        onClick={() => (window.location.href = "/wedding#top")}
                    >
                        Wedding & Engagement
                    </div>

                    {/* GOLD SUB-CATEGORIES */}
                    {activeCollection === "gold" && (
                        <div className="sub-dropdown">
                            <a href="/gold#gold-earrings">Earrings</a>
                            <a href="/gold#gold-rings">Rings</a>
                            <a href="/gold#gold-pendant">Pendant</a>
                            <a href="/gold#gold-anklet">Anklet</a>
                            <a href="/gold#gold-necklace-chain">Necklace & Chain</a>
                            <a href="/gold#gold-bracelet">Bracelet</a>
                        </div>
                    )}

                    {/* SILVER SUB-CATEGORIES */}
                    {activeCollection === "silver" && (
                        <div className="sub-dropdown">
                            <a href="/silver#silver-earrings">Earrings</a>
                            <a href="/silver#silver-rings">Rings</a>
                            <a href="/silver#silver-pendant">Pendant</a>
                            <a href="/silver#silver-anklet">Anklet</a>
                            <a href="/silver#silver-necklace-chain">Necklace & Chain</a>
                            <a href="/silver#silver-bracelet">Bracelet</a>
                        </div>
                    )}
                </div>
            )}
        </nav>
    );
};

export default Navbar;